







import './KisweStudioLogo.scss'
import { defineComponent, computed } from '@vue/composition-api'
import { useTeamBranding } from '@/modules/teams/compositions'
import Media from '../Media'

export default defineComponent({
  name: 'KisweStudioLogo',
  components: {
    Media
  },
  props: {
    link: {
      type: String,
      required: false,
      default: ''
    },
    isBrandedLogo: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup (props) {
    const { branding } = useTeamBranding()
    const showBrandedLogo = computed(() => branding.value.logoUrl && props.isBrandedLogo)
    return {
      branding,
      loadedComponent: computed(() => require('@/assets/kiswe-logo-red.svg')),
      showBrandedLogo
    }
  }
})
